import Cookies from 'js-cookie';

export const CookieKeys = {
  ORDER_ID: 'order_id',
  CART_ID: 'cart_id',
} as const;

export const cookieUtils = {
  // Save order ID
  setOrderId: (orderId: string) => {
    Cookies.set(CookieKeys.ORDER_ID, orderId, { expires: 30 }); // Expires in 30 days
    localStorage.setItem('order_id', orderId); // Backup in localStorage
  },

  // Get order ID
  getOrderId: (): string | undefined => {
    const cookieValue = Cookies.get(CookieKeys.ORDER_ID);
    const localStorageValue = localStorage.getItem('order_id');
    
    // Sync if one exists but not the other
    if (cookieValue && !localStorageValue) {
      localStorage.setItem('order_id', cookieValue);
    } else if (localStorageValue && !cookieValue) {
      Cookies.set(CookieKeys.ORDER_ID, localStorageValue, { expires: 30 });
    }
    
    return cookieValue || localStorageValue || undefined;
  },

  // Remove order ID
  removeOrderId: () => {
    Cookies.remove(CookieKeys.ORDER_ID);
    localStorage.removeItem('order_id');
  },

  // Save cart ID
  setCartId: (cartId: string) => {
    Cookies.set(CookieKeys.CART_ID, cartId, { expires: 30 }); // Expires in 30 days
    localStorage.setItem('cart_id', cartId); // Backup in localStorage
  },

  // Get cart ID
  getCartId: (): string | undefined => {
    const cookieValue = Cookies.get(CookieKeys.CART_ID);
    const localStorageValue = localStorage.getItem('cart_id');
    
    // Sync if one exists but not the other
    if (cookieValue && !localStorageValue) {
      localStorage.setItem('cart_id', cookieValue);
    } else if (localStorageValue && !cookieValue) {
      Cookies.set(CookieKeys.CART_ID, localStorageValue, { expires: 30 });
    }
    
    return cookieValue || localStorageValue || undefined;
  },

  // Remove cart ID
  removeCartId: () => {
    Cookies.remove(CookieKeys.CART_ID);
    localStorage.removeItem('cart_id');
  },

  // Clear all order-related cookies and localStorage
  clearOrderCookies: () => {
    Cookies.remove(CookieKeys.ORDER_ID);
    Cookies.remove(CookieKeys.CART_ID);
    localStorage.removeItem('order_id');
    localStorage.removeItem('cart_id');
  },

  // Aliases for clearing individual items (for backward compatibility)
  clearCartId: () => {
    Cookies.remove(CookieKeys.CART_ID);
    localStorage.removeItem('cart_id');
  },

  clearOrderId: () => {
    Cookies.remove(CookieKeys.ORDER_ID);
    localStorage.removeItem('order_id');
  }
};